import {Component, OnInit} from '@angular/core';
import {AlertService} from "../../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {GalleryService} from "./service/gallery.service";
import {Gallery} from "./model/gallery";

@Component({
    templateUrl: './galleryForm.component.html',
    styleUrls: ['./galleryForm.component.scss']
})

export class GalleryFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    units: any[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private galleryService: GalleryService
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Galleries');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            tagName: ['', Validators.required],
            active: [''],
            mobileApplicationStartScreen: [''],
        });

        if (!this.isAddMode) {
            this.galleryService.getById(this.id)
                .pipe(first())
                .subscribe((x: Gallery) => {
                    this.f.name.setValue(x.name);
                    this.f.tagName.setValue(x.tagName);
                    this.f.active.setValue(x.active);
                    this.f.mobileApplicationStartScreen.setValue(x.mobileApplicationStartScreen);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createGallery();
        } else {
            this.updateGallery();
        }
    }

    private createGallery() {
        this.galleryService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Gallery added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['/cms/galleries']);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateGallery() {
        this.galleryService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['/cms/galleries']);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
